module.exports = __webpack_public_path__ + "img/doodle-1.0d52db8e.png";